import { Avatar as MuiAvatar } from "@mui/material";
import { getAvatarPhotoUrl } from "Utils/Image/getProfilePhotoUrl";
import type { RefObject, MouseEvent } from "react";
import type { AppUser } from "State/Auth/Models/AuthStateModels";

type Size = "small" | "medium";

const STYLES: Record<
  Size,
  { width: number; height: number; fontSize: string }
> = {
  small: {
    width: 35,
    height: 35,
    fontSize: "0.875rem",
  },
  medium: {
    width: 50,
    height: 50,
    fontSize: "1.25rem",
  },
};

type Props = {
  user: AppUser;
  size: Size;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  elementRef?: RefObject<HTMLDivElement | null>;
};

export const Avatar = ({ user, size, onClick, elementRef }: Props) => {
  const { width, height, fontSize } = STYLES[size];
  const {
    firstName,
    lastName,
    login,
    profilePicture,
    userPublicID,
    activeContextPublicID,
  } = user;
  const photoUrl = getAvatarPhotoUrl(
    userPublicID,
    activeContextPublicID,
    profilePicture,
  );
  const acronym = (
    firstName && lastName ? `${firstName[0]}${lastName[0]}` : login[0]
  ).toLocaleUpperCase();

  return (
    <MuiAvatar
      ref={elementRef}
      src={photoUrl}
      onClick={onClick}
      sx={{
        bgcolor: "primary.main",
        width,
        height,
        fontSize,
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {photoUrl ? undefined : acronym}
    </MuiAvatar>
  );
};
